import { createAsyncThunk } from '@reduxjs/toolkit';

import PAGE_API from './page.api';

export const listPageAction = createAsyncThunk<
any,
Page.GetPageDetailPayload
>('page.getList', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.listPageAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const detailPageAction = createAsyncThunk<any, { data: string }>(
  'page.getDetail',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await PAGE_API.detailPageAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const createPageAction = createAsyncThunk<
any,
Page.PagePostDetailPayload
>('page.create', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.createPageAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const updatePageAction = createAsyncThunk<
any,
Page.PagePostDetailPayload
>('page.update', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.updatePageAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const deletePageAction = createAsyncThunk<any, Page.DeletePagePayload>(
  'page.delete',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await PAGE_API.deletePageAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const settingShowPageAction = createAsyncThunk<any, Page.SettingShowPagePayload>(
  'page.settingShow',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await PAGE_API.settingShowPageAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);
